import { css } from "@emotion/react";
import colors from "assets/css/colors";

export default css`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: 32px;
  height: 32px;
  background-color: transparent;
  color: ${colors.grey};
  border-radius: 16px;
  transition-duration: 0.3s;
  transition-property: color, background-color;

  &[disabled] {
    opacity: 0.5;
  }

  &:hover:not([disabled]) {
    background-color: ${colors.lightGrey};
    color: ${colors.textGrey};
  }
`;
